<template>
  <component
    :is="shouldShowLink ? 'iLink' : 'iText'"
    :href="shouldShowLink ? builderNoNavHref : undefined"
    v-bind="fullTextOptionsAttributes"
    :style-overrides="myStyleOverrides"
    :border-top="myBorderSides?.top ?? 0"
    :border-bottom="myBorderSides?.bottom ?? 0"
    :border-left="myBorderSides?.left ?? 0"
    :border-right="myBorderSides?.right ?? 0"
    :target="shouldShowLink ? target : undefined"
    :rel="shouldShowLink ? rel : undefined"
    :width="fullTextOptionsAttributes.width"
    :min-width="fullTextOptionsAttributes.minWith"
    :max-width="fullTextOptionsAttributes.maxWith"
    :background-position="shouldShowLink ? getOptionValue(BackgroundPosition) : undefined"
    :background-size="shouldShowLink ? getOptionValue(BackgroundSize) : undefined"
    :background-repeat="shouldShowLink ? getOptionValue(BackgroundRepeat) : undefined"
    :hover-background-position="shouldShowLink ? getOptionValue(BackgroundPosition, BaseOption.$states.HOVER) : undefined"
    :hover-background-size="shouldShowLink ? getOptionValue(BackgroundSize, BaseOption.$states.HOVER) : undefined"
    :hover-background-repeat="shouldShowLink ? getOptionValue(BackgroundRepeat, BaseOption.$states.HOVER) : undefined"
    @click="editMode && $event.preventDefault()"
  >
    <slot>
      <iRichText
        v-if="(!hasLabel && editMode) || (hasTextContent && !editMode && !hasLabel)"
        ref="richTextElement"
        :model-value="initialValue"
        prevent-new-line
        :placeholder="editMode ? 'Enter text here' : ''"
        :preview="previewMode"
        :show-toolbar="false"
        :show-bubble-menu="true"
        :tools-to-disable="['text-align', 'link', 'bullet-list']"
        :style-overrides="{
          borderWidth: 'none',
          borderRadius: 'none',
          paddingLeft: 'none',
          paddingRight: 'none',
          paddingTop: 'none',
          paddingBottom: 'none',
        }"
        v-bind="textOnlyAttributes"
        @click="editMode && handleClick($event)"
        @blur="handleBlur"
        @keydown.enter="handleBlur"
        @update:model-value="handleTextOptionUpdate($event)"
      />
      <template v-else-if="hasLabel">
        <PrefixSuffixWrapper
          v-if="getOptionValue(Prefix) || getOptionValue(Suffix)"
          :prefix="getOptionValue(Prefix)"
          :suffix="getOptionValue(Suffix)"
          :style-bindings="textOnlyAttributes"
        >
          {{ label }}
        </PrefixSuffixWrapper>
        <template v-else>
          {{ label }}
        </template>
      </template>
    </slot>
  </component>
</template>

<script>
import {
  UrlElementMixin,
} from "%/dynamic-component-editor/standard-elements/url-element/url-element-mixin";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import TextOptions from "%/dynamic-component-editor/bundles/text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import PrefixSuffixWrapper from "%/dynamic-component-editor/components/PrefixSuffixWrapper.vue";
import Suffix from "%/dynamic-component-editor/options/suffix";
import Prefix from "%/dynamic-component-editor/options/prefix";
import HrefAction from "%/dynamic-component-editor/options/href-action";
import BackgroundImage from "%/dynamic-component-editor/options/background-image";
import BackgroundGradient from "%/dynamic-component-editor/options/background-gradient";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";

export default {
  name: "UrlElement",
  components: { PrefixSuffixWrapper },
  elementPanelSettings: {
    tags: ["link", "url", "anchor", "href"],
    displayName: "Link",
    displayIcon: "hyperlink",
    elementGroup: "general",
  },
  mixins: [UrlElementMixin],
  data() {
    return {
      Suffix,
      Prefix,
      BackgroundGradient,
      BackgroundImage,
    };
  },
  computed: {
    // In the builder the inner rich-text editor swallows the click before the
    // anchor's @click handler, so drop the href entirely in edit scope — an
    // anchor with no href can't navigate, wherever the click lands.
    builderNoNavHref() {
      if (this.editMode || this.inBuilderEditScope) {
        return null;
      }
      return this.href || this.computedHref;
    },
  },
  optionBundles: [
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    new BrandedTextStyleOptions({
      "default.text-branding-style-option": "paragraph",
    }),
    BasicTextOptions,
    TextOptions,
    SpacingOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "hug",
      "default.layout-height": "hug",
    }, {
      "layout-height": true,
      "max-height": true,
      "min-height": true,
    }),
    BorderOptions,
    new BackgroundOptions({}, {
      "background-image": true,
    }),
    AnimationEffectsOptions,
  ],
  options: [
    HrefAction,
  ],
};
</script>

<style scoped lang="scss">
</style>
